import { makeStyles, Grid } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import SWLink from '../_components/SWLink'
import ContentFeature from '../_components/ContentFeature'

const useStyles = makeStyles<Theme, ColormixForecastProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'ColormixForecast' }
)

export interface ColormixForecastProps {
  classes?: StyleClasses<typeof useStyles>
}

function ColormixForecast(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentFeature
        title={
          <>
            Colormix <br />
            Forecast
          </>
        }
        description={
          <>
            Our annual Colormix® Forecast keeps you in the know and ahead of the trend. Take a look and discover the
            ways these curated collections shape the future of design.
          </>
        }
        cta={
          <Grid item xs={12}>
            <SWLink
              href="https://www.sherwin-williams.com/en-us/color/color-collections/colormix-forecast/2026?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=colormix-2026"
              label="EXPLORE COLORMIX"
              theme="dark"
              style={{ width: '100%' }}
            />
          </Grid>
        }
        colorTileA={{
          color: '#B0BFCE',
          colorCode: '6535',
          colorName: 'Solitude',
          darkText: true
        }}
        colorTileB={{
          color: '#666560',
          colorCode: '9599',
          colorName: 'Limestone',
          darkText: false
        }}
        image={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/colormix-forecast.jpg'}
        imageAlt="Sherwin-Williams Colormix Forecast"
      />
    </div>
  )
}

export default ColormixForecast
